import { END_USER_SORT_KEYS } from "pages/admin-app/end-user/end-user.constants";
import { useIntl } from "react-intl";

interface FilterOption {
  value: string;
  label: string;
}

interface Props {
  appliedFilters: Record<string, string>;
  onRemoveFilter: (filterKey: string) => void;
  mainFilterOptions: FilterOption[];
}

const BaseFilterChip = ({
  appliedFilters,
  onRemoveFilter,
  mainFilterOptions,
}: Props) => {
  const intl = useIntl();

  const filterEntries = Object.entries(appliedFilters);

  if (filterEntries.length === 0) {
    return null;
  }

  const chips = filterEntries.map(([mainKey, subValue]) => {
    const mainOption = mainFilterOptions.find(
      (opt) => opt.value === mainKey
    ) || {
      value: mainKey,
      label: mainKey,
    };

    const displayValue =
      mainKey === END_USER_SORT_KEYS.AUTOMATED_RG
        ? Number(subValue) === 1
          ? intl.formatMessage({ id: "customComponents.yes" })
          : intl.formatMessage({ id: "customComponents.no" })
        : subValue;

    return (
      <button
        key={mainKey}
        className="usadmin-filter__chip"
        onClick={() => onRemoveFilter(mainKey)}
      >
        <span className="usadmin-filter__text-title">{mainOption.label}:</span>
        <span className="usadmin-filter__text">{displayValue}</span>
      </button>
    );
  });

  return <div className="usadmin-button__chips_container">{chips}</div>;
};

export default BaseFilterChip;
